import React from 'react';
import { Box, Typography, TextField, RadioGroup, Radio, OutlinedInput } from '@mui/material';
import { MeetingTypes } from '../../../util/meetingTypes';

const MeetingLocation = ({
    customKey, 
    locationInput, 
    phoneNumber,
    setPhoneNumber,
    canInviteeCall,
    isDisabled,
    errors, 
    handleInputChange,
    handleRadioChange
}) => {


    const controlProps = (item) => {
        return {
            checked: canInviteeCall === item,
            onChange: handleRadioChange,
            value: item,
            inputProps: { "aria-label": item },
        };
    }
    return (
        <Box>
            {/* Conditionally render the address input field for "In Person" */}
            {customKey === MeetingTypes.IN_PERSON.key && (
                <Box width="100%">
                    <TextField
                        fullWidth
                        placeholder="Enter your address"
                        value={locationInput}
                        onChange={handleInputChange}
                         variant="outlined"
                        sx={{
                            flex: 1,
                            maxWidth: '500px',
                            height: '35px',
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                                borderBottom: '1px solid lightgray',
                            },
                        }}
                    />
                </Box>
            )}

            {/* Conditionally render for "Phone Call" */}
            {customKey === MeetingTypes.PHONE_CALL.key && (
                <RadioGroup>
                    <Box display="flex" flexDirection="column">
                        <Typography>
                            <Radio {...controlProps(false)} disabled={isDisabled} /> I will call my invitee
                        </Typography>

                    </Box>
                    <Box display="flex" flexDirection="column">
                        <Box display="flex" alignItems="center" >
                            {/* Radio and Label */}
                            <Typography>
                                <Radio {...controlProps(true)} disabled={isDisabled} /> Let my invitee call on:
                            </Typography>

                            {/* Conditionally Render the Input Field with Bottom Border */}
                            {canInviteeCall && (
                                <OutlinedInput
                                    required={!isDisabled && true}
                                    disabled={isDisabled}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                    value={phoneNumber}
                                     variant="standard" // Set variant to standard to give it an underline style
                                    sx={{
                                        flex: 1,
                                        maxWidth: '500px',
                                        height: '35px',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                            borderBottom: '1px solid lightgray',
                                        },
                                    }}
                                />
                            )}
                        </Box>

                    </Box>
                </RadioGroup>
            )}

            {/* Conditionally render for "Video Meeting" */}
            {customKey === MeetingTypes.VIDEO_MEETING.key && (
                <Box mt={2} width="100%">
                    <TextField
                        disabled={isDisabled}
                        fullWidth
                        label="Video Link"
                        variant="outlined"
                        placeholder="Enter video link"
                        value={locationInput}
                        onChange={handleInputChange}
                        sx={{
                            width: "100%",
                            maxWidth: "500px",
                            mt: 2
                        }}
                    />
                    {/* {locationInput && (
                        <Link to={locationInput} sx={{ textDecoration: 'none', mb: 2 }}>
                            <Box onClick={redirectToVideo}>
                                View video <Launch fontSize="small" />
                            </Box>
                        </Link>
                    )} */}
                </Box>
            )}
        </Box>
    );
};

export default MeetingLocation;
